import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  BreakpointCustomizable,
  PButtonTile,
  PLinkTile,
  TileAspectRatio,
} from '@porsche-design-system/components-react';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { App, AppLink } from '@/config/app';
import { useApplicationConfigs } from '@/hooks';

export const ApplicationTile = ({
  application,
}: {
  application: App | AppLink;
}) => {
  const { t } = useTranslation();
  const appConfigs = useApplicationConfigs();
  const { hasAccess, href, imgSrc, name } = appConfigs[application];

  const props: {
    compact: BreakpointCustomizable<boolean>;
    label: string;
    description: string;
    aspectRatio: BreakpointCustomizable<TileAspectRatio>;
    'aria-label': string;
    weight: BreakpointCustomizable<'regular' | 'semi-bold'>;
    gradient: boolean;
    style: CSSProperties;
  } = {
    description: name,
    compact: true,
    label: t('applicationTile.label', { application: name }),
    aspectRatio: '16/9',
    'aria-label': name,
    weight: 'regular',
    gradient: true,
    style: { colorScheme: 'dark' },
  };

  return hasAccess ? (
    <PLinkTile {...props} href={href}>
      <img src={imgSrc} alt={name} />
    </PLinkTile>
  ) : (
    <ApplicationPreview>
      <PButtonTile {...props} disabled icon="lock">
        <img src={imgSrc} alt={name} />
      </PButtonTile>
    </ApplicationPreview>
  );
};

const ApplicationPreview = styled('div', {
  base: {
    backgroundColor: 'background.canvas',
    opacity: 0.4,
  },
});
